import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import router
// import './index.css'; // Import CSS (nếu có)

const setFavicon = () => {
  const favicon =
    document.querySelector('link[rel="icon"]') ||
    document.createElement("link");
  favicon.type = "image/x-icon";
  favicon.rel = "icon";
  favicon.href = "/favicon.ico"; // Path relative to domain root
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }
};

// Set favicon immediately
setFavicon();

const app = createApp(App);

app.use(router); // Sử dụng Vue Router

app.mount("#app");
